// extracted by mini-css-extract-plugin
export default {"brandPromo":"XE-z","carousel":"YE-z"};